import React from "react";
import { Container, Row, Col } from "shards-react";
import styled from "styled-components";
import {
  SearchIndicators,
  Footer,
  TabsLogistics,
  Agency,
  Indicators,
  BannerContent,
  LawContent,
} from "shared/components";
import { ToastContainer, toast } from "react-toastify";
import Layout from "shared/container/Layout";

const HomePage = styled.div``;
const Home = (props) => {
  return (
    <Layout>
      <div className="main-content">
        <HomePage>
          <ToastContainer />
          <BannerContent />
          <TabsLogistics />
          <SearchIndicators />
          <Indicators />
          <LawContent/>
          <Agency />
        </HomePage>
      </div>
      <Footer />
    </Layout>
  );
};

export default Home;
